import { render, staticRenderFns } from "./Voices.vue?vue&type=template&id=be2ae152&"
import script from "./Voices.vue?vue&type=script&lang=js&"
export * from "./Voices.vue?vue&type=script&lang=js&"
import style0 from "./Voices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports